import { Button } from "@chakra-ui/react";
import { Download } from "lucide-react";
import { buildExcelBlob, downloadExcelBlob } from "../helpers/excel";
import { Tooltip } from "./ui/tooltip";

type Props<T extends Record<string, unknown>> = {
  fileName: string;
  tableColumns: readonly {
    key: string;
    label: string;
    exportTransform?: (value: T) => string | number;
  }[];
  items: T[];
};
export const DownloadToExcelButton = <T extends Record<string, unknown>>({
  fileName,
  items,
  tableColumns,
}: Props<T>): JSX.Element | null => {
  const downloadExcel = () => {
    const columns = tableColumns.filter((c) => c.exportTransform);

    const content = [
      columns.map((column) => column.label),
      ...items.map((item) => columns.map((c) => c.exportTransform?.(item))),
    ];

    try {
      downloadExcelBlob(buildExcelBlob(content), fileName);
    } catch (error) {
      console.error("Error generating or downloading Excel file:", error);
    }
  };

  return items.length > 0 ? (
    <Tooltip content="Descargar página" positioning={{ placement: "top" }}>
      <Button
        variant="ghost"
        size="md"
        onClick={downloadExcel}
        _hover={{
          color: "primary.500",
        }}
      >
        <Download size={22} />
      </Button>
    </Tooltip>
  ) : null;
};
